{
    "Profile_Vehicles.vehicles": "FR: Vehicles",
    "Profile_Vehicles.vehicle": "FR: Vehicle {number}",
    "Profile_Vehicles.driver": "FR: Driver {number}"
}
